import { render, staticRenderFns } from "./VaSimplePalettePicker.vue?vue&type=template&id=2b3d3eb6&"
import script from "./VaSimplePalettePicker.vue?vue&type=script&lang=js&"
export * from "./VaSimplePalettePicker.vue?vue&type=script&lang=js&"
import style0 from "./VaSimplePalettePicker.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports